<script lang="ts" setup>
import { GenderEnum } from "@/enums/mateEnums";
import { useMate } from "@/stores/mate";
import { computed } from "vue";

const props = defineProps<{
  gender: GenderEnum;
  referenceMedia: Pick<Media, "id" | "url"> | null;
  generatedMedia: Media | null;
}>();
const emit = defineEmits<{
  (e: "update:generatedMedia", value: Media | null): void;
  (e: "showStyleSelection"): void;
  (e: "regenerate"): void;
  (e: "onAvatarClick"): void;
}>();
const mateStore = useMate();

const displayUrl = computed(() => {
  const suffix = "?x-oss-process=image/resize,w_300/format,webp";
  if (props.generatedMedia?.url) {
    return `${props.generatedMedia?.url}${suffix}`;
  } else if (mateStore.currentMate?.mediaUrl) {
    return `${mateStore.currentMate?.mediaUrl}${suffix}`;
  } else {
    return "";
  }
});
</script>
<template>
  <div class="flex flex-col gap-10 items-center justify-center">
    <div class="text-white text-[2rem] font-bold text-center">
      {{ $t("loginmodal.characterAppearance") }}
    </div>
    <div class="flex flex-col gap-2 items-center">
      <div
        class="rounded overflow-hidden shadow-lg w-32 md:w-64 aspect-[3/4]"
        @click="emit('onAvatarClick')"
      >
        <VanImage
          :src="displayUrl"
          class="w-full aspect-[3/4]"
          fit="object-contain pointer-events-none"
        >
          <template v-slot:loading>
            <span class="loading loading-sm loading-ring" />
          </template>
        </VanImage>
      </div>
      <div class="flex items-center justify-center gap-2">
        <button
          class="btn btn-neutral rounded"
          @click="emit('showStyleSelection')"
        >
          <i class="iconfont icon-paint" />
          {{ $t("loginmodal.selectStyle") }}
        </button>
        <button class="btn btn-neutral rounded" @click="emit('regenerate')">
          <i class="iconfont icon-refresh" />
          {{ $t("loginmodal.regenerate") }}
        </button>
      </div>
    </div>
  </div>
</template>
